export const decodeJWT = (token: string): any => {
  try {
    if (!token || token.split('.').length !== 3) {
      return {};
    }
    
    const base64Url = token.split('.')[1];
    if (!base64Url) {
      return {};
    }
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      window.atob(base64)
        .split('')
        .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    return JSON.parse(jsonPayload);
  } catch (error) {
    console.error('Error decoding JWT token:', error);
    return {};
  }
};